

export default {
  name: 'ProductInfoReviewsItemAction',
  props: {
    review: {
      type: Object,
    },
  },
  data() {
    return {
      isAdd: false,
      count: this.review.helpfulCount,
    };
  },
  computed: {
    textHelpful() {
      return `${this.count} ${this.count === 1
        ? `${this.$pdpConstants.PERSON}` : `${this.$pdpConstants.PEOPLE}`} found this helpful`;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
  },
  methods: {
    changeStatus() {
      const status = this.isAdd ? `${this.$pdpConstants.REMOVE}` : `${this.$pdpConstants.ADD}`;
      const reviewId = this.review.id;
      this.$emit('change-status', status, reviewId);
      this.isAdd = !this.isAdd;
      if (this.isAdd) {
        this.count += 1;
      } else {
        this.count -= 1;
      }
    },
  },
};
